import DateEnum  from './dateEnum';
import  MSConstant  from '@/i18ns/vi/i18nEnum.js';
export const dateDataDefault = [
    {
        SettingValue: DateEnum.ThisWeek,
        SettingName: MSConstant.ReportPeriod.ThisWeek,
    },
    {
        SettingValue: DateEnum.LastWeek,
        SettingName: MSConstant.ReportPeriod.LastWeek,
    },
    {
        SettingValue: DateEnum.ThisMonth,
        SettingName: MSConstant.ReportPeriod.ThisMonth,
    },
    {
        SettingValue: DateEnum.LastMonth,
        SettingName: MSConstant.ReportPeriod.LastMonth,
    },
    {
        SettingValue: DateEnum.ThisQuarter,
        SettingName: MSConstant.ReportPeriod.ThisQuarter,
    },
    {
        SettingValue: DateEnum.LastQuarter,
        SettingName: MSConstant.ReportPeriod.LastQuarter,
    },
    {
        SettingValue: DateEnum.ThisYear,
        SettingName: MSConstant.ReportPeriod.ThisYear,
    },
    {
        SettingValue: DateEnum.LastYear,
        SettingName: MSConstant.ReportPeriod.LastYear,
    },
    {
        SettingValue: DateEnum.SixFirstMonth,
        SettingName: MSConstant.ReportPeriod.FirtsHalfYear,
    },
    {
        SettingValue: DateEnum.SixLastMonth,
        SettingName: MSConstant.ReportPeriod.SecondHalfYear,
    },
    {
        SettingValue: DateEnum.Custom,
        SettingName: MSConstant.ReportPeriod.Custom,
    },
]

/**
 * Date combobox mặc định mà ko có 6 tháng đầu, 6 tháng cuối năm
 */
export const dateDataDefaultWithoutSixMonth = [
    {
        SettingValue: DateEnum.ThisWeek,
        SettingName: MSConstant.ReportPeriod.ThisWeek,
    },
    {
        SettingValue: DateEnum.LastWeek,
        SettingName: MSConstant.ReportPeriod.LastWeek,
    },
    {
        SettingValue: DateEnum.ThisMonth,
        SettingName: MSConstant.ReportPeriod.ThisMonth,
    },
    {
        SettingValue: DateEnum.LastMonth,
        SettingName: MSConstant.ReportPeriod.LastMonth,
    },
    {
        SettingValue: DateEnum.ThisQuarter,
        SettingName: MSConstant.ReportPeriod.ThisQuarter,
    },
    {
        SettingValue: DateEnum.LastQuarter,
        SettingName: MSConstant.ReportPeriod.LastQuarter,
    },
    {
        SettingValue: DateEnum.ThisYear,
        SettingName: MSConstant.ReportPeriod.ThisYear,
    },
    {
        SettingValue: DateEnum.LastYear,
        SettingName: MSConstant.ReportPeriod.LastYear,
    },
    {
        SettingValue: DateEnum.Custom,
        SettingName: MSConstant.ReportPeriod.Custom,
    },
]

const dateDataSimply = [
    {
        SettingValue: DateEnum.ThisWeek,
        SettingName: MSConstant.ReportPeriod.ThisWeek,
    },
    {
        SettingValue: DateEnum.ThisMonth,
        SettingName: MSConstant.ReportPeriod.ThisMonth,
    },
    {
        SettingValue: DateEnum.ThisQuarter,
        SettingName: MSConstant.ReportPeriod.ThisQuarter,
    },
    {
        SettingValue: DateEnum.ThisYear,
        SettingName: MSConstant.ReportPeriod.ThisYear,
    },
    {
        SettingValue: DateEnum.Custom,
        SettingName: MSConstant.ReportPeriod.Custom,
    },
]

const dateDataSimplyWithoutWeek = [
    {
        SettingValue: DateEnum.ThisMonth,
        SettingName: MSConstant.ReportPeriod.ThisMonth,
    },
    {
        SettingValue: DateEnum.ThisQuarter,
        SettingName: MSConstant.ReportPeriod.ThisQuarter,
    },
    {
        SettingValue: DateEnum.ThisYear,
        SettingName: MSConstant.ReportPeriod.ThisYear,
    },
    {
        SettingValue: DateEnum.Custom,
        SettingName: MSConstant.ReportPeriod.Custom,
    },
]
const dateDataCustom = [
    {
        SettingValue: DateEnum.January,
        SettingName: MSConstant.ReportPeriod.January,
    },
    {
        SettingValue: DateEnum.February,
        SettingName: MSConstant.ReportPeriod.February,
    },
    {
        SettingValue: DateEnum.March,
        SettingName: MSConstant.ReportPeriod.March,
    },
    {
        SettingValue: DateEnum.April,
        SettingName: MSConstant.ReportPeriod.April,
    },
    {
        SettingValue: DateEnum.May,
        SettingName: MSConstant.ReportPeriod.May,
    },
    {
        SettingValue: DateEnum.June,
        SettingName: MSConstant.ReportPeriod.June,
    },
    {
        SettingValue: DateEnum.July,
        SettingName: MSConstant.ReportPeriod.July,
    },
    {
        SettingValue: DateEnum.August,
        SettingName: MSConstant.ReportPeriod.August,
    },
    {
        SettingValue: DateEnum.September,
        SettingName: MSConstant.ReportPeriod.September,
    },
    {
        SettingValue: DateEnum.October,
        SettingName: MSConstant.ReportPeriod.October,
    },
    {
        SettingValue: DateEnum.November,
        SettingName: MSConstant.ReportPeriod.November,
    },
    // {
    //     SettingValue: DateEnum.December,
    //     SettingName: MSConstant.ReportPeriod.December,
    // },
    // {
    //     SettingValue: -1,
    //     SettingName: MSConstant.ReportPeriod.QuarterI,
    // },
    // {
    //     SettingValue: -2,
    //     SettingName: MSConstant.ReportPeriod.QuarterII,
    // },
    // {
    //     SettingValue: -3,
    //     SettingName: MSConstant.ReportPeriod.QuarterIII,
    // },
    // {
    //     SettingValue: -4,
    //     SettingName: MSConstant.ReportPeriod.QuarterIV,
    // }
]
const dateDataMonth = [
    {
        SettingValue: DateEnum.January,
        SettingName: MSConstant.ReportPeriod.January,
    },
    {
        SettingValue: DateEnum.February,
        SettingName: MSConstant.ReportPeriod.February,
    },
    {
        SettingValue: DateEnum.March,
        SettingName: MSConstant.ReportPeriod.March,
    },
    {
        SettingValue: DateEnum.April,
        SettingName: MSConstant.ReportPeriod.April,
    },
    {
        SettingValue: DateEnum.May,
        SettingName: MSConstant.ReportPeriod.May,
    },
    {
        SettingValue: DateEnum.June,
        SettingName: MSConstant.ReportPeriod.June,
    },
    {
        SettingValue: DateEnum.July,
        SettingName: MSConstant.ReportPeriod.July,
    },
    {
        SettingValue: DateEnum.August,
        SettingName: MSConstant.ReportPeriod.August,
    },
    {
        SettingValue: DateEnum.September,
        SettingName: MSConstant.ReportPeriod.September,
    },
    {
        SettingValue: DateEnum.October,
        SettingName: MSConstant.ReportPeriod.October,
    },
    {
        SettingValue: DateEnum.November,
        SettingName: MSConstant.ReportPeriod.November,
    },
    {
        SettingValue: DateEnum.December,
        SettingName: MSConstant.ReportPeriod.December,
    },

]

export const dateDataQuarter = [{
    SettingValue: 1,
    SettingName: MSConstant.ReportPeriod.QuarterI,
},
{
    SettingValue: 2,
    SettingName: MSConstant.ReportPeriod.QuarterII,
},
{
    SettingValue: 3,
    SettingName: MSConstant.ReportPeriod.QuarterIII,
},
{
    SettingValue: 4,
    SettingName: MSConstant.ReportPeriod.QuarterIV,
}]
export default {
    dateDataDefault,
    dateDataSimply,
    dateDataSimplyWithoutWeek,
    dateDataMonth,
    dateDataQuarter,
    dateDataCustom
}